import { AxiosError, isAxiosError } from 'axios';

const EXPECTED_NETWORK_ERROR_CODES: ReadonlyArray<string> = [
  AxiosError.ERR_NETWORK,
  AxiosError.ECONNABORTED,
  AxiosError.ETIMEDOUT,
  AxiosError.ERR_CANCELED,
];

const isExpectedNetworkAxiosError = (error: unknown): boolean =>
  isAxiosError(error) && EXPECTED_NETWORK_ERROR_CODES.includes(error.code ?? '');

export { isExpectedNetworkAxiosError };
